import { useQuery } from "@tanstack/react-query";
import { createFileRoute, Outlet, useRouter } from "@tanstack/react-router";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { AppLayout } from "@/components/layout/app-layout";
import { ErrorState } from "@/components/shared/error-state";
import { loadAuthenticatedUser } from "@/lib/auth-route-guard";
import { DEMO_WORKSPACE_QUERY_KEY, fetchDemoWorkspace } from "@/lib/demo-api";
import { setDemoGeneration } from "@/lib/demo-generation";
import { useAuthStore } from "@/stores/auth";

export const Route = createFileRoute("/_authed")({
  beforeLoad: loadAuthenticatedUser,
  errorComponent: AuthedError,
  component: AuthedLayout,
});

function AuthedLayout() {
  const isDemo = useAuthStore((state) => state.user?.deploymentMode === "demo");
  return (
    <AppLayout>
      {isDemo ? <DemoGenerationSync /> : null}
      <Outlet />
    </AppLayout>
  );
}

/** ADP-271: remember which demo data generation this page was loaded against. */
function DemoGenerationSync() {
  const { data } = useQuery({ queryKey: DEMO_WORKSPACE_QUERY_KEY, queryFn: fetchDemoWorkspace });
  useEffect(() => {
    if (data?.generation) setDemoGeneration(data.workspaceId, data.generation.completedAt);
  }, [data]);
  return null;
}

/** First-load `/auth/me` failures (no verified user yet) and uncaught child route errors. */
function AuthedError() {
  const { t } = useTranslation();
  const router = useRouter();
  return (
    <div className="flex min-h-svh items-center justify-center">
      <ErrorState message={t("errors:unknown")} onRetry={() => void router.invalidate()} />
    </div>
  );
}
